import request from "../../Request";
import authStore from "../../../Stores/AuthStore/AuthStore";
import {rThen} from "../../requestThen";

export let getChildrensGroup = async (kindegartenId=null) => {

    return request.get(`/api/children_group/get_groups/${kindegartenId === null? authStore.decodeJwt.userId : kindegartenId}`, true).then(r => {
        return rThen(r)
    })
}